import styled from "styled-components";
import { ScreenPlatform } from "@store/ducks/Screen/screen.type";

interface StylesheetProps {
  platform: ScreenPlatform;
}
export const Container = styled.div<StylesheetProps>`
  padding-top: 85px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  align-content: flex-start;
  padding-bottom: 20px !important;

  &.page {
    padding-top: 1rem;
  }

  @media (max-width: 800px) { // Mobile
    padding-bottom: 0;
  }
`;
export const ClickableCell = styled.button`
  background: none;
  border: none;
  color: #007bff; // Or your theme's primary link color
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  font-family: inherit;

  &:hover {
    color: #0056b3; // A darker shade for hover effect
  }
`;
